module.exports = __webpack_public_path__ + "img/our-contributors.ede2cb4d.png";